// a library to wrap and simplify api calls
// import Api from './PhiApi'

export default class PhiContent {

    constructor(options) {
        this.phiRef = options

        // this.get = function* (that, options) {
        //     let token = that.phiRef.getSession()

        //     let uuid = options && options.uuid ? options.uuid : null
        //     if (token) {
        //         let response = yield Api.getNode({inContentUuid : uuid})
                
        //         if (response.ok && response.data && response.data.results) {
        //             return that.parseData(response.data.results[0])
        //         }
        //         else {
        //             return { error: response.problem }
        //         }
        //     }
        //     return null
        // }

        // this.parseData = function (result) {     
        //   let custom = result.custom_field ? JSON.parse(result.custom_field)[0] : {}
        //   let content = Object.assign({}, custom.json_value, { row_id: result.id, node_id: custom.node_id, node_active: result.node_active, node_association_active: result.node_association_active, firstname: result.firstname, lastname: result.lastname, uuid: result.uuid, created_time: custom.created_time })
        //   return content
        // }

    }


}
